export const jobs = {
    'meta': {
        'title': 'Oferty pracy • Psychiatria dzieci i młodzieży, psychiatria osób dorosłych, psychoterapia, psychologia | COLLIGO',
        'description': 'Lista ofert pracy w Centrum Psychiatrii i Psychoterapii COLLIGO'
    },
    'url': {
        'address': '/oferty-pracy/',
        'title': 'Oferty pracy • Psychiatria dzieci i młodzieży, psychiatria osób dorosłych, psychoterapia, psychologia | COLLIGO',
        'name': 'Oferty pracy'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dziecięcy w Toruniu. Psychiatra w Toruniu. Psychoterapia w Toruniu. Psychologia w Toruniu. Gabinety w dogodnym miejscu Torunia.'
        }
    }
}